import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SongData } from 'services/store/distribution/types';
import { ReleaseSongStatus } from 'services/api/entities/distribution/release';
import {
  SummaryContainer,
  MetadataStatusContainer,
  MetadataStatusCircle,
  MetadataStatusLabel,
} from './styled';

type PropsType = {
  songs: SongData[];
};

const TracklistSummary = ({ songs }: PropsType) => {
  const { t } = useTranslation();

  const { status } = songs[0];

  const labelText = useMemo(() => {
    switch (status) {
      case ReleaseSongStatus.VALID:
        return t('distribution:tracklist:songs:metadata:valid');
      case ReleaseSongStatus.ERROR:
        return t('distribution:tracklist:songs:metadata:error');
      default:
        return t('distribution:tracklist:songs:metadata:warning');
    }
  }, [t, status]);

  return (
    <SummaryContainer>
      <MetadataStatusContainer>
        <MetadataStatusCircle status={status} />
        <MetadataStatusLabel status={status}>{labelText}</MetadataStatusLabel>
      </MetadataStatusContainer>
    </SummaryContainer>
  );
};

export default TracklistSummary;
